// FIX 20260801-headerhide / FIX 20260802-headerhide2 / FIX 20260802-hhjs
// 校正画面・動画視聴ページのみ。三本線ボタンを1個追加し、ヘッダーの開閉だけを行う。
// 従来は「隠すかどうか」をCSSの @media と :has() だけで判定していたが、
//   (1) iPad等のChromeはCSSの画面高がツールバー分だけ実際の表示高と食い違う
//   (2) :has() が使えないブラウザでは一切効かない
// ため、実際に見えている高さで判定して body にクラスを付ける方式に変更した。
// 他の要素・イベントには一切干渉しない(preventDefault/stopPropagationはしない)。
(function () {
  var FAB_ID = 'tm-header-fab';
  var LIMIT = 700;

  function isInspector() {
    return !!document.querySelector('#animation-inspector-container, .animation-inspector-container');
  }
  function isPublicVideo() {
    return !!document.querySelector('.public-view-animation');
  }
  function isTarget() {
    return !!(document.body && (isInspector() || isPublicVideo()));
  }
  function isSmallLandscape() {
    var vv = window.visualViewport;
    var h = (vv && vv.height) ? vv.height : window.innerHeight;
    var w = (vv && vv.width) ? vv.width : window.innerWidth;
    return h > 0 && w > h && h <= LIMIT;
  }
  function closeHeader() { document.body.classList.remove('tm-header-open'); }

  function apply() {
    if (!document.body) return;
    var on = isSmallLandscape();
    var cl = document.body.classList;
    if (on && isInspector()) { cl.add('tm-hh'); } else { cl.remove('tm-hh'); }
    if (on && isPublicVideo()) { cl.add('tm-hh-pub'); } else { cl.remove('tm-hh-pub'); }
    if (!on) closeHeader();
  }

  function makeFab() {
    if (document.getElementById(FAB_ID)) return;
    var b = document.createElement('button');
    b.id = FAB_ID;
    b.type = 'button';
    b.className = 'tm-header-fab';
    b.setAttribute('aria-label', 'メニュー');
    b.innerHTML = '<i class="fas fa-bars"></i>';
    b.addEventListener('click', function (e) {
      e.stopPropagation();
      document.body.classList.toggle('tm-header-open');
    });
    document.body.appendChild(b);
  }

  function onDocClick(e) {
    if (!document.body.classList.contains('tm-header-open')) return;
    var h = document.getElementById('navbar-common');
    if (h && h.contains(e.target)) return;
    if (e.target && e.target.closest && e.target.closest('#' + FAB_ID)) return;
    closeHeader();
  }
  function onKey(e) { if (e.key === 'Escape' || e.keyCode === 27) closeHeader(); }

  function init() {
    if (!isTarget()) return;
    makeFab();
    document.addEventListener('click', onDocClick, true);
    document.addEventListener('keydown', onKey);
    apply();
    try {
      window.addEventListener('resize', apply);
      window.addEventListener('orientationchange', apply);
      window.addEventListener('pageshow', apply);
      if (window.visualViewport) {
        window.visualViewport.addEventListener('resize', apply);
        window.visualViewport.addEventListener('scroll', apply);
      }
    } catch (_) {}
    setTimeout(apply, 300);
    setTimeout(apply, 1200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
